import { cn } from "@/lib/utils";

interface SignalProgressProps {
  current: number;
  total: number;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function SignalProgress({ current, total, className, size = "md" }: SignalProgressProps) {
  const sizeClasses = {
    sm: "w-1.5 h-1.5",
    md: "w-2 h-2",
    lg: "w-3 h-3",
  };

  return (
    <div className={cn("flex items-center gap-1", className)}>
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={cn(
            "rounded-full transition-colors duration-200",
            sizeClasses[size],
            i < current ? "bg-primary" : "bg-muted"
          )}
        />
      ))}
      <span className="ml-1.5 text-xs font-medium text-muted-foreground">
        {current}/{total}
      </span>
    </div>
  );
}
